module.exports = __webpack_public_path__ + "img/canbadge_daishi_70_90mm_line.a5dc9621.png";